module.exports = __webpack_public_path__ + "static/media/admin_panel_settings_black_24dp.6a3c873d.svg";